import { useCallback } from 'react';
import { z } from 'zod';
import { UseFormProps, useForm as useFormLib } from 'react-hook-form';
import { Resolver, zodResolver } from '@hookform/resolvers/zod';

type SchemaForResolver = Parameters<Resolver>['0'];

export const useForm = <SchemaType extends SchemaForResolver>(
	zodSchema: SchemaType,
	options: UseFormProps<z.infer<SchemaType>> = {},
) => {
	type FieldsType = z.infer<SchemaType>;

	const formMethods = useFormLib<FieldsType>({
		resolver: zodResolver(zodSchema),
		...options,
	});

	const { handleSubmit: handleSubmitLib } = formMethods;

	const handleSubmit: typeof handleSubmitLib = useCallback(
		(onSuccess, onError) => {
			if (process.env.NODE_ENV === 'development' && !onError) {
				return handleSubmitLib(onSuccess, console.error);
			}

			return handleSubmitLib(onSuccess, onError);
		},
		[handleSubmitLib],
	);

	return {
		...formMethods,
		handleSubmit,
	};
};
